[
  
  {
    "pageName": "Dashboard",
    "hasChildren": false,
    "route": "/main/landing-page-layout",
    "icon": "landing-page",
    "ref": "landing-page-layout"
  },
  {
    "pageName": "Messages",
    "hasChildren": false,
    "route": "/main/messaging",
    "icon": "messages",
    "ref": "message"
  },
  {
    "pageName": "Child Reports",
    "hasChildren": false,
    "route": "/main/child-reports",
    "icon": "reports",
    "ref": "child-reports"
  },
  {
    "pageName": "Child Feedbacks",
    "hasChildren": false,
    "route": "/main/child-feedbacks",
    "icon": "reports",
    "ref": "child-feedbacks"
  },
  {
    "pageName": "Events",
    "hasChildren": false,
    "route": "/main/events",
    "icon": "calendar",
    "ref": "events"
  }
]


